import { createReducer, on } from '@ngrx/store';
import { toastShow } from '../actions/toast.action';
import { ToastModel } from '../../domain/models/toast.model';

export interface ToastState {
    toastModel: ToastModel | null;
}

export const initialState: ToastState = {
  toastModel: null
};

export const toastReducer = createReducer(
  initialState,
  on(toastShow, (state, { toastModel }) => ({ ...state, toastModel }))
);
